import { render, staticRenderFns } from "./FeaturedInArticle.vue?vue&type=template&id=2002d8ea&scoped=true&lang=pug&"
import script from "./FeaturedInArticle.vue?vue&type=script&lang=js&"
export * from "./FeaturedInArticle.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedInArticle.vue?vue&type=style&index=0&id=2002d8ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002d8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2002d8ea')) {
      api.createRecord('2002d8ea', component.options)
    } else {
      api.reload('2002d8ea', component.options)
    }
    module.hot.accept("./FeaturedInArticle.vue?vue&type=template&id=2002d8ea&scoped=true&lang=pug&", function () {
      api.rerender('2002d8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/FeaturedInArticle.vue"
export default component.exports